import type { QuestionnaireState } from "../../types";

export const handleSetEditModeAction = (
  state: QuestionnaireState,
  payload: boolean,
): QuestionnaireState => {
  const isExitingEditMode = state.isEditing && !payload;

  // Remove temporary edit sections when exiting edit mode
  const sections = isExitingEditMode
    ? state.sections.filter(section => section.displayAs !== "edit")
    : state.sections;

  return {
    ...state,
    isEditing: payload,
    sections,
  };
};
